import type { IconSvgObject } from './types';

const CornerLeftDownIcon: IconSvgObject = [
  ["path", { d: "M14 15.002L9 20.002L4 15.002M9 19.002V7.00195C9 5.3451 10.3431 4.00195 12 4.00195H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerLeftDownIcon;
